exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control.ng-valid[required] {\n  border-left: 5px solid #42A948;\n}\n\n.form-control.ng-invalid.ng-dirty,\n.form-control.ng-invalid.ng-touched {\n  border-left: 5px solid #a94442;\n}\n\n\n.badge {\n  position: relative;\n  width: 100%;\n  padding-top: 100%;\n  border-radius: 10%;\n}\n\n.badge img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  mix-blend-mode: screen;\n  filter: grayscale(100%) contrast(100%);\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.markdown-button-position {\n  margin-bottom: 3px;\n}\n\n.markdown-link-position {\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/badges/badges-details/badges-details.component.css
// module id = ../../../../../src/app/modules/badges/badges-details/badges-details.component.css
// module chunks = main